// @ts-nocheck
import { useDocumentRepository } from '../repositories';
// TODO: Folder operations, acknowledgment operations, version history queries,
// update, and delete are specialized and not covered by the Document repository's
// CRUD. Remove compat imports once the repository supports these operations.
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import {
  UPDATE_DOCUMENT_MUTATION,
  DELETE_DOCUMENT_MUTATION,
  DOCUMENT_FOLDERS_QUERY,
  CREATE_DOCUMENT_FOLDER_MUTATION,
  ACKNOWLEDGE_DOCUMENT_MUTATION,
  DOCUMENT_ACKNOWLEDGMENTS_QUERY,
  DOCUMENT_VERSIONS_QUERY,
} from '../graphql/operations';
import type {
  Document,
  DocumentFolder,
  DocumentAcknowledgment,
} from '../types/document';

// Keep the main queries exported for any external consumers.
// These reference the same operations used by the repository internally.
export { DOCUMENTS_QUERY, DOCUMENT_QUERY } from '../graphql/operations';

// ── Queries ─────────────────────────────────────────────────────────

export function useDocuments(variables?: {
  page?: number;
  perPage?: number;
  category?: string;
  employeeId?: string;
  search?: string;
  folderId?: string;
}) {
  const repo = useDocumentRepository();
  return repo.useList(variables);
}

export function useDocument(id: string) {
  const repo = useDocumentRepository();
  return repo.useGet(id);
}

// TODO: Migrate to repository pattern once a DocumentFolder repository exists.
export function useDocumentFolders(parentId?: string) {
  return useCompatQuery(DOCUMENT_FOLDERS_QUERY, {
    variables: { parentId: parentId || undefined },
  });
}

// TODO: Migrate to repository pattern once custom queries are supported.
export function useDocumentAcknowledgments(documentId: string) {
  return useCompatQuery(DOCUMENT_ACKNOWLEDGMENTS_QUERY, {
    variables: { documentId },
    skip: !documentId,
  });
}

// TODO: Migrate to repository pattern once custom queries are supported.
export function useDocumentVersions(originalId: string) {
  return useCompatQuery(DOCUMENT_VERSIONS_QUERY, {
    variables: { originalId },
    skip: !originalId,
  });
}

// ── Mutations ───────────────────────────────────────────────────────

export function useUploadDocument() {
  const repo = useDocumentRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

// TODO: Migrate to repository pattern once Document repository supports update.
export function useUpdateDocument() {
  return useCompatMutation(UPDATE_DOCUMENT_MUTATION);
}

// TODO: Migrate to repository pattern once Document repository supports delete.
export function useDeleteDocument() {
  return useCompatMutation(DELETE_DOCUMENT_MUTATION);
}

// TODO: Migrate to repository pattern once a DocumentFolder repository exists.
export function useCreateFolder() {
  return useCompatMutation(CREATE_DOCUMENT_FOLDER_MUTATION, {
    refetchQueries: [{ query: DOCUMENT_FOLDERS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useAcknowledgeDocument() {
  return useCompatMutation(ACKNOWLEDGE_DOCUMENT_MUTATION, {
    refetchQueries: [{ query: DOCUMENT_ACKNOWLEDGMENTS_QUERY }],
  });
}
